export enum VisitNoteType {
  Intake = 1,
  Subjective = 2,
  Vitals = 3,
  Objective = 4,
  Assessment = 5,
  Plan = 6,
  Prognosis = 7,
  VisitBuilder = 9,
  Discharge = 10,
  AttachmentsandConsents = 11,
  Surgery = 12,
  AbortVisit = 13,
  Private = 14,
}
